import React from 'react';
import { cn } from '@/lib/utils';

type LegalSectionProps = {
  title: string;
  children: React.ReactNode;
  className?: string;
};

export function LegalSection({ title, children, className }: LegalSectionProps) {
  return (
    <section className={cn('flex flex-col gap-4', className)}>
      <h2 className="text-3xl font-semibold text-foreground">{title}</h2>
      <div className="flex flex-col gap-4 text-gray-600">{children}</div>
    </section>
  );
}
